module.exports = __webpack_public_path__ + "assets/images/logo-inverse.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logo-inverse.png
 ** module id = 24
 ** module chunks = 0
 **/